var React = require('react');

function Provision (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 9 0 6l12-6 12 6-6 3 6 3-6 3 6 3-12 6-12-6 6-3-6-3 6-3zm6 .764L4.472 6 12 2.236 19.528 6 12 9.764zM4.472 18l3.764-1.882L12 18l3.764-1.882L19.528 18 12 21.764 4.472 18z","fill":"#fff"}));
}

Provision.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Provision;

Provision.default = Provision;
